import { isControlPlaneHost } from './runtime';

// @AI_COMMENTS: DEFINITIVE FIX - API URL configuration for production
export const getApiBaseUrl = (): string => {
  const host = window.location.hostname;
  const protocol = window.location.protocol;

  // O control plane usa a API no mesmo host via proxy nginx e nao herda a
  // URL de API de nenhum tenant.
  if (isControlPlaneHost(host)) {
    return `${protocol}//${host}`;
  }
  
  // PRODUCTION FIX: Para Andressa Hattori, usar subdomínio dedicado da API
  if (host.includes('andressahattori.com.br')) {
    const apiUrl = 'https://api.andressahattori.com.br';
    return apiUrl;
  }
  
  // PRODUCTION FIX: Para Capivara Imóveis, usar subdomínio dedicado da API
  if (host.includes('capivaraimoveis.com.br')) {
    const apiUrl = 'https://api.capivaraimoveis.com.br';
    return apiUrl;
  }
  
  // O backend local pode usar outra porta para isolar ambientes de teste.
  if (host === 'localhost' || host.startsWith('192.168.') || host.startsWith('10.') || host === '127.0.0.1') {
    const apiUrl = process.env.REACT_APP_API_URL || `${protocol}//${host}:8100`;
    return apiUrl;
  }
  
  // Para outros domínios, verificar se tem REACT_APP_API_URL
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Fallback: usar o mesmo domínio sem porta
  const apiUrl = `${protocol}//${host}`;
  
  return apiUrl;
};
